export const TABS = {
	REGION: { value: 'region', text: 'Region' },
	PARTNERS: { value: 'partners', text: 'Partners' }
};
